module.exports = __webpack_public_path__ + "img/loading.22c5d157.gif";